"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleRadioOption = exports.StyledRadioOptionContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("../../../helpers");
exports.StyledRadioOptionContainer = styled_components_1.default.div(function (_a) {
    var theme = _a.theme, isSelected = _a.isSelected, isReadOnly = _a.isReadOnly, status = _a.status;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    border-width: ", ";\n    min-width: 522px;\n    max-width: 632px;\n    min-height: 48px;\n\n    &:hover {\n      background: ", ";\n\n      .gmui-radio-intermediate {\n        fill: ", ";\n        stroke: none;\n      }\n    }\n\n    &:focus {\n      background: ", ";\n      outline: none;\n\n      & ", " {\n        fill: ", ";\n        stroke: none;\n      }\n    }\n\n    &:focus:not(:focus-visible) {\n      outline: none;\n    }\n  "], ["\n    border-color: ", ";\n    background-color: ", ";\n    border-width: ", ";\n    min-width: 522px;\n    max-width: 632px;\n    min-height: 48px;\n\n    &:hover {\n      background: ", ";\n\n      .gmui-radio-intermediate {\n        fill: ", ";\n        stroke: none;\n      }\n    }\n\n    &:focus {\n      background: ", ";\n      outline: none;\n\n      & ", " {\n        fill: ", ";\n        stroke: none;\n      }\n    }\n\n    &:focus:not(:focus-visible) {\n      outline: none;\n    }\n  "])), (0, helpers_1.getBorderColor)(isReadOnly, isSelected, status, theme), (0, helpers_1.getRadioOptionColors)(isReadOnly, status, theme), isSelected && !isReadOnly ? '2px' : '1px', !isReadOnly && theme.Colors.neutral30, isReadOnly
        ? theme.Colors.neutral20
        : isSelected
            ? theme.Colors.neutral30
            : theme.Colors.white, !isReadOnly ? theme.Colors.neutral30 : '', isReadOnly ? '.gmui-radio-intermediate-disabled' : '.gmui-radio-intermediate', isReadOnly
        ? theme.Colors.neutral20
        : isSelected
            ? theme.Colors.neutral30
            : theme.Colors.white);
});
exports.StyleRadioOption = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var Colors = _a.theme.Colors, isReadOnly = _a.isReadOnly;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), isReadOnly ? Colors.neutral120 : 'inherit');
});
var templateObject_1, templateObject_2, templateObject_3;
